document.addEventListener('DOMContentLoaded', function () {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    // === 1. Update Wishlist Count in Header ===
    function updateWishlistCount() {
    const wishlistCountEl = document.querySelector('.wishlist_product_count');
  
    if (wishlistCountEl) {
      if (wishlist.length > 0) {
        wishlistCountEl.textContent = wishlist.length;
        wishlistCountEl.style.display = 'flex';
      } else {
        wishlistCountEl.textContent = '';
        wishlistCountEl.style.display = 'none';
      }
    }
  }
    updateWishlistCount();
    // === 2. Sync Wishlist Icon State on Page Load ===
    document.querySelectorAll('.wishlist_icon').forEach(function (iconWrapper) {
      const productId = iconWrapper.getAttribute('data-product-id');
      const isInWishlist = wishlist.some(item => item.id === productId);
      const emptyIcon = iconWrapper.querySelector('.wishlist-empty-icon');
      const fillIcon = iconWrapper.querySelector('.wishlist-fill-icon');

      if (isInWishlist) {
        if (emptyIcon) emptyIcon.style.display = 'none';
        if (fillIcon) fillIcon.style.display = 'inline-block';
      } else {
        if (emptyIcon) emptyIcon.style.display = 'inline-block';
        if (fillIcon) fillIcon.style.display = 'none';
      }

      // === 3. Click Handler for Toggling Wishlist ===
      iconWrapper.addEventListener('click', function (e) {
        e.stopPropagation();

        const productTitle = iconWrapper.getAttribute('data-product-title');
        const productPrice = iconWrapper.getAttribute('data-product-price');
        const productImage = iconWrapper.getAttribute('data-product-image');
        const productURL = iconWrapper.getAttribute('data-product-url');

        const existingIndex = wishlist.findIndex(p => p.id === productId);

        if (existingIndex === -1) {
          // Add to wishlist
          wishlist.push({
            id: productId,
            title: productTitle,
            price: productPrice,
            image: productImage,
            url: productURL,
          });

          if (emptyIcon) emptyIcon.style.display = 'none';
          if (fillIcon) fillIcon.style.display = 'inline-block';

          console.log('Added to wishlist!');
        } else {
          // Remove from wishlist
          wishlist.splice(existingIndex, 1);

          if (emptyIcon) emptyIcon.style.display = 'inline-block';
          if (fillIcon) fillIcon.style.display = 'none';

          console.log('Removed from wishlist!');
        }

        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        updateWishlistCount();

        if (document.querySelector('.wishlist_list_ul.wishlist')) {
          renderWishlist();
        }
      });
    });
    // === 4. Render Wishlist Page (if on it) ===
    function renderWishlist() {
      wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
      const wishlistContentWrapper = document.querySelector('.wishlist_list_ul.wishlist');
      if (!wishlistContentWrapper) return;

      wishlistContentWrapper.innerHTML = '';

      if (wishlist.length === 0) {
        wishlistContentWrapper.innerHTML = '<p>No products in wishlist.</p>';
        return;
      }

      wishlist.forEach(product => {
        const productHTML = `
          <li class="grid__item scroll-trigger animate--slide-in" data-cascade="" >
                 
<div class="card-wrapper product-card-wrapper underline-links-hover">
    <div class=" card card--standard card--media  " style="--ratio-percent: 100.0%;">
      <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100.0%;">
        <div class="card__media">
            <div class="media media--transparent media--hover-effect"> 
              <img srcset="${product.image}" src="${product.image}" sizes="(min-width: 1400px) 317px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="MP-DDR3-1866 - 128GB (32GBx4) DDR3 ECC 1333MHz Memory For 2013 Mac Pro Model 6.1" class="motion-reduce" loading="lazy" width="480" height="480">              
</div>
          </div><div class="card__content">
          <div class="card__information">
            <h3 class="card__heading">
              <a href="" id="" class="full-unstyled-link" >
                ${product.title}
              </a>
            </h3>
          </div>
<!-- card badge code -->
             <div class="card__badge__wrapper">
          <div class="wishlist_card wishlist_button">
            <span class="svg-wrapper wishlist_icon" onclick="toggleWishlistFromPage(this)" data-product-id="${product.id}" data-product-title="${product.title}" data-product-price="${product.price}" data-product-image="${product.image}">
              <span class="wishlist-empty-icon" style="display:none;">
              <svg class="icon icon-wihlist" xmlns="http://www.w3.org/2000/svg" width="25.139" height="22.118" viewBox="0 0 25.139 22.118">
  <path id="Icon_feather-heart" data-name="Icon feather-heart" d="M24.139,6.32a6.22,6.22,0,0,0-8.8,0l-1.2,1.2-1.2-1.2a6.221,6.221,0,1,0-8.8,8.8l1.2,1.2,8.8,8.8,8.8-8.8,1.2-1.2a6.22,6.22,0,0,0,0-8.8Z" transform="translate(-1.573 -3.747)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" style="
"></path>
</svg>
</span>
              <span class="wishlist-fill-icon" style="display:inline-block;"><svg class="icon icon-wihlist" xmlns="http://www.w3.org/2000/svg" width="25.139" height="22.118" viewBox="0 0 25.139 22.118">
  <path id="Icon_feather-heart" data-name="Icon feather-heart" d="M24.139,6.32a6.22,6.22,0,0,0-8.8,0l-1.2,1.2-1.2-1.2a6.221,6.221,0,1,0-8.8,8.8l1.2,1.2,8.8,8.8,8.8-8.8,1.2-1.2a6.22,6.22,0,0,0,0-8.8Z" transform="translate(-1.573 -3.747)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" style="
    fill: #000;
"></path>
</svg></span>
            </span>
          </div>
          <div class="card__badge top left"><span id="NoMediaStandardBadge-template--16941815332926__product-grid-296103005" class="badge badge--bottom-left color-scheme-3">Sale</span></div>
        </div>

    
  <!-- end card badge code -->
        </div>
      </div>
      <div class="card__content">
        <div class="card__information">
          <div class="rating_with_vendor">
              <div class="rating_star"><svg xmlns="http://www.w3.org/2000/svg" class="star_rating_svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Group_481" data-name="Group 481" width="95.839" height="14.708" viewBox="0 0 95.839 14.708"> <defs> <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"> <stop offset="0" stop-color="#ffc72a"></stop> <stop offset="1" stop-color="#ffa632"></stop></linearGradient></defs><path id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M17.488,8.466h-5.2L10.707,3.75a.573.573,0,0,0-1.075,0L8.052,8.466H2.816a.567.567,0,0,0-.566.566.416.416,0,0,0,.011.1.544.544,0,0,0,.237.4l4.274,3.012-1.64,4.769a.567.567,0,0,0,.194.636.547.547,0,0,0,.318.138A.693.693,0,0,0,6,17.955l4.172-2.973,4.172,2.973a.662.662,0,0,0,.354.127.508.508,0,0,0,.315-.138.56.56,0,0,0,.194-.636l-1.64-4.769L17.8,9.5l.1-.088a.541.541,0,0,0-.417-.944Z" transform="translate(-2.25 -3.375)" fill="url(#linear-gradient)"></path><path id="Icon_ionic-ios-star-2" data-name="Icon ionic-ios-star" d="M17.488,8.466h-5.2L10.707,3.75a.573.573,0,0,0-1.075,0L8.052,8.466H2.816a.567.567,0,0,0-.566.566.416.416,0,0,0,.011.1.544.544,0,0,0,.237.4l4.274,3.012-1.64,4.769a.567.567,0,0,0,.194.636.547.547,0,0,0,.318.138A.693.693,0,0,0,6,17.955l4.172-2.973,4.172,2.973a.662.662,0,0,0,.354.127.508.508,0,0,0,.315-.138.56.56,0,0,0,.194-.636l-1.64-4.769L17.8,9.5l.1-.088a.541.541,0,0,0-.417-.944Z" transform="translate(37.75 -3.375)" fill="url(#linear-gradient)"></path><path id="Icon_ionic-ios-star-3" data-name="Icon ionic-ios-star" d="M17.488,8.466h-5.2L10.707,3.75a.573.573,0,0,0-1.075,0L8.052,8.466H2.816a.567.567,0,0,0-.566.566.416.416,0,0,0,.011.1.544.544,0,0,0,.237.4l4.274,3.012-1.64,4.769a.567.567,0,0,0,.194.636.547.547,0,0,0,.318.138A.693.693,0,0,0,6,17.955l4.172-2.973,4.172,2.973a.662.662,0,0,0,.354.127.508.508,0,0,0,.315-.138.56.56,0,0,0,.194-.636l-1.64-4.769L17.8,9.5l.1-.088a.541.541,0,0,0-.417-.944Z" transform="translate(17.75 -3.375)" fill="url(#linear-gradient)"></path><path id="Icon_ionic-ios-star-4" data-name="Icon ionic-ios-star" d="M17.488,8.466h-5.2L10.707,3.75a.573.573,0,0,0-1.075,0L8.052,8.466H2.816a.567.567,0,0,0-.566.566.416.416,0,0,0,.011.1.544.544,0,0,0,.237.4l4.274,3.012-1.64,4.769a.567.567,0,0,0,.194.636.547.547,0,0,0,.318.138A.693.693,0,0,0,6,17.955l4.172-2.973,4.172,2.973a.662.662,0,0,0,.354.127.508.508,0,0,0,.315-.138.56.56,0,0,0,.194-.636l-1.64-4.769L17.8,9.5l.1-.088a.541.541,0,0,0-.417-.944Z" transform="translate(57.75 -3.375)" fill="url(#linear-gradient)"></path><path id="Icon_ionic-ios-star-5" data-name="Icon ionic-ios-star" d="M17.488,8.466h-5.2L10.707,3.75a.573.573,0,0,0-1.075,0L8.052,8.466H2.816a.567.567,0,0,0-.566.566.416.416,0,0,0,.011.1.544.544,0,0,0,.237.4l4.274,3.012-1.64,4.769a.567.567,0,0,0,.194.636.547.547,0,0,0,.318.138A.693.693,0,0,0,6,17.955l4.172-2.973,4.172,2.973a.662.662,0,0,0,.354.127.508.508,0,0,0,.315-.138.56.56,0,0,0,.194-.636l-1.64-4.769L17.8,9.5l.1-.088a.541.541,0,0,0-.417-.944Z" transform="translate(77.75 -3.375)" fill="url(#linear-gradient)"></path></svg></div>
              <div class="vendor"><span class="visually-hidden">Vendor:</span>
                  <div class="caption-with-letter-spacing ">Ramjet</div></div>   
            </div>
          <h3 class="card__heading h5" id="title-template--16941815332926__product-grid-296103005">
            <a href="${product.url}" id="" class="full-unstyled-link" aria-labelledby="">
             ${product.title}
            </a>
          </h3>
          <div class="card-information">
            

            <span class="caption-large light"></span>
<div class="
      price  price--on-sale">
    <div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>
          <span class="price-item price-item--regular">
            ${product.price} 
          </span></div>
      <div class="price__sale">
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
          <span class="visually-hidden visually-hidden--inline">Sale price</span>
        <span class="price-item price-item--sale price-item--last">
          ${product.price} 
        </span>
      </div>
      <small class="unit-price caption hidden">
        <span class="visually-hidden">Unit price</span>
        <span class="price-item price-item--last">
          <span></span>
          <span aria-hidden="true">/</span>
          <span class="visually-hidden">&nbsp;per&nbsp;</span>
          <span>
          </span>
        </span>
      </small>
    </div></div>


</div>
        </div>
        
        
 
        <div class="card__badge top left"><span id="Badge-template--16941815332926__product-grid-296103005" class="badge badge--bottom-left color-scheme-3">Sale</span></div>
      </div>
    </div>
  </div></li>`;
        wishlistContentWrapper.innerHTML += productHTML;
      });
    }
    renderWishlist(); 
  });

  // === 5. Global Add-to-Wishlist Function (Used via inline onclick) ===
  function addToWishlist(element) {
    const productId = element.getAttribute('data-product-id');
    const productTitle = element.getAttribute('data-product-title');
    const productPrice = element.getAttribute('data-product-price');
    const productImage = element.getAttribute('data-product-image');
    const productURL = element.getAttribute('data-product-url');

    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    const alreadyInWishlist = wishlist.some(product => product.id === productId);

    if (!alreadyInWishlist) {
      wishlist.push({ id: productId, title: productTitle, price: productPrice, image: productImage, url: productURL });
      localStorage.setItem('wishlist', JSON.stringify(wishlist));

      const emptyIcon = element.querySelector('.wishlist-empty-icon');
      const fillIcon = element.querySelector('.wishlist-fill-icon');
      if (emptyIcon) emptyIcon.style.display = 'none';
      if (fillIcon) fillIcon.style.display = 'inline-block';

      const wishlistCountEl = document.querySelector('.wishlist_product_count');
      if (wishlistCountEl) wishlistCountEl.textContent = `${wishlist.length}`;

      console.log('Product added to wishlist!');
    } else {
      console.log('Product already in wishlist!');
    }
  }

  // === 6. Remove from Wishlist Function ===
  function removeFromWishlist(element) {
    const productId = element.getAttribute('data-product-id');
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    wishlist = wishlist.filter(product => product.id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    // Remove product card from DOM
    const productCard = element.closest('.grid__item');
    if (productCard) productCard.remove();

    const wishlistCountEl = document.querySelector('.wishlist_product_count');
    if (wishlistCountEl) wishlistCountEl.textContent = `(${wishlist.length})`;
  }

function toggleWishlistFromPage(element) {
  const productId = element.getAttribute('data-product-id');
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  const index = wishlist.findIndex(p => p.id === productId);

  if (index !== -1) {
    // Remove from wishlist
    wishlist.splice(index, 1);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    // Remove from DOM
    const productCard = element.closest('.grid__item');
    if (productCard) productCard.remove();

    // Update count
    const wishlistCountEl = document.querySelector('.wishlist_product_count');
    if (wishlistCountEl) {
      wishlistCountEl.textContent = wishlist.length > 0 ? `${wishlist.length}` : '';
      wishlistCountEl.style.display = wishlist.length > 0 ? 'flex' : 'none';
    }

    // If list is empty, show message
    const wishlistContentWrapper = document.querySelector('.wishlist_list_ul.wishlist');
    if (wishlistContentWrapper && wishlist.length === 0) {
      wishlistContentWrapper.innerHTML = '<p>No products in wishlist.</p>';
    }

    console.log('Removed from wishlist from page!');
  }
}